import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import * as yup from 'yup';

import { Dropdown, AttentionBox, Checkbox, Dialog, DialogContentContainer, IconButton, Link } from "@vibe/core";
import { Info } from "@vibe/icons";

import Monday from "../../auth/useMonday.jsx";
import Loader from "../../libs/loader.jsx";

import Notification from "../../libs/notification.jsx";

class Filter extends React.Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            'filters': this.props.filters,
            'errors': this.props.errors,
            'options': {
                'boards': [],
                'workspaces': []
            },
            'values': {
                'boards': [],
                'workspaces': [],
                'archive': false
            },
            'cache': {
            'boards': false,
            'workspaces': false,
            'firstload': false,
            }
        };
        
        this.handleAddWorkspaces = this.handleAddWorkspaces.bind(this);
        this.handleRemoveWorkspaces = this.handleRemoveWorkspaces.bind(this);
        
        this.handleAddBoards = this.handleAddBoards.bind(this);
        this.handleRemoveBoards = this.handleRemoveBoards.bind(this);
        
        this.handleChangeCheckbox = this.handleChangeCheckbox.bind(this);
        
        this.loader = React.createRef();
        
        this.synStateTimer = false;
    }
    
    async promisedSetState(newState)
    { 
        var state = this.state;
        for(let key of Object.keys(newState))
        {
            state[key] = newState[key];
        }
        
        this.state = state;
        
        var this_component = this;
        if(this.synStateTimer==false)
        {
            this.synStateTimer = setTimeout( () => { 
                this_component.setState( {...this_component.state} );
                this_component.synStateTimer = false; 
            }, 100);
        }
        
        return true;
    }
    
    async updateFilters(filters)
    {
        if(this.props.onUpdate != undefined)
        {
            this.props.onUpdate(filters);
            return false;
        }
        else
        {
            await this.promisedSetState( {'filters': {...filters} } );
            return true;
        }
    }
    
    async handleAddWorkspaces(options)
    {
        var this_component = this;
        
        var allworkspaces = options.filter(function(option) { return option.value == '-1'; }).length;
        
        if(allworkspaces)
        {
            options = options.filter(function(option) { return option.value == '-1'; });
        }
        
        var workspaces = [];
        if(Array.isArray(options))
        {
            workspaces = options.map((item,index) => { return item.value });
        }

        var filters = {...this_component.state.filters};
        filters.workspaces = workspaces;
        await this.updateFilters(filters);
    }
    
    async handleRemoveWorkspaces(option)
    {
        var this_component = this;
        
        var workspaces = this_component.state.filters.workspaces.filter(function(workspace) { return option.value != workspace; });
        
        var filters = {...this_component.state.filters};
        filters.workspaces = workspaces;
        await this.updateFilters(filters);
    }
    
    async handleAddBoards(options)
    {
        var this_component = this;
        //console.log('handleAddBoards', options);
        var allboards = options.filter(function(option) { return option.value == '-1'; }).length;
        
        if(allboards)
        {
            options = options.filter(function(option) { return option.value == '-1'; });
        }
        
        var boards = [];
        if(Array.isArray(options))
        {
            boards = options.map((item,index) => { return item.value });
        }

        var filters = {...this_component.state.filters};
        filters.boards = boards;
        await this.updateFilters(filters);
    }
    
    async handleRemoveBoards(option)
    {
        var this_component = this;
        //console.log('filter handleChange2Boards', option);
        let boards = this_component.state.filters.boards.filter(function(board) { return option.value != board; });
        
        
        var filters = {...this_component.state.filters};
        filters.boards = boards;
        await this.updateFilters(filters);
    }
    
    async handleChangeCheckbox(event, type)
    {
        var this_component = this;
        
        var values = {...this_component.state.values};
        var filters = {...this_component.state.filters};
        
        values[type] = (values[type] != true);
        
        await this.promisedSetState( {'values': {...values} } );
        
        filters[type] = values[type];
        await this.updateFilters(filters);
    }
    
    async updateCheckboxes()
    {
        var this_component = this;
        var filters = {...this_component.state.filters};
        var values = {...this_component.state.values};

        if( 'archive' in filters )
        {
            values['archive'] = filters['archive'];
        }

        await this_component.promisedSetState( {'values': {...values} } );
    }
    
    async updateWorkspaceOptions()
    {
        var this_component = this;
        
        var options = {...this_component.state.options};
        var values = {...this_component.state.values};
        
        options.workspaces = [];
        
        //add manual option
        var option = { 'value': '-1', 'label': 'All Workspaces' };
        options.workspaces.push( option );
        
        var workspaces = this_component.state.cache.workspaces;
        
        for(var i in workspaces)
        {
            var workspace = workspaces[i];
            
            if(
                ( 
                    //state 'active'
                    (values.archive==false && (['active'].includes(workspace.state)))
                )
                ||
                (
                    //state 'active','archived','deleted'
                    (values.archive == true)
                )
            )
            {
                var option = { 'value': workspace.id.toString(), 'label': workspace.name };
                if(workspace.state != 'active') option['label'] = workspace.name+' ('+workspace.state+')';
                
                options.workspaces.push( option );
            }
        }
        await this.promisedSetState( {'options': {...options} } );
        
        //remove workspaces from filters if they don't exists in available options
        if( ('filters' in this_component.state) && ('workspaces' in this_component.state.filters) && Array.isArray(this_component.state.filters.workspaces))
        {
            var filters = {...this_component.state.filters};
            var workspaces = filters.workspaces.filter(function(workspace_id) { 
                return options.workspaces.filter(function(workspace) { return workspace.value==workspace_id; }).length;
            });
            
            if(filters.workspaces.length!=workspaces.length)
            {
                filters.workspaces = workspaces;
                await this.updateFilters(filters);
                return true;
            }
        }
        //end        
        
        //set selected options
        values.workspaces = [];
        var workspaces = [];
        if( ('filters' in this_component.state) && ('workspaces' in this_component.state.filters) && Array.isArray(this_component.state.filters.workspaces))
        {
            this_component.state.filters.workspaces.forEach(function(workspace_id) {
                
                var filtered = this_component.state.options.workspaces.filter(function(workspace) { return workspace_id == workspace.value; });
                workspaces = workspaces.concat(filtered.filter((item) => workspaces.indexOf(item) < 0));

            });
        }
        values.workspaces = workspaces
        await this.promisedSetState( {'values': {...values} } );
        //end
        
        await this.updateBordsOptions();
        
        return true;
    }
    
    
    async updateBordsOptions()
    {
        var this_component = this;
        //console.log('filter componentDidMount', this.state);
        var values = {...this_component.state.values};
        var options = {...this_component.state.options};
        
        options.boards = [];
        //add manual option
        var option = { 'value': '-1', 'label': 'All Boards' };
        options.boards.push( option );
        
        var boards = this_component.state.cache.boards;
        var workspaces = this_component.state.cache.workspaces;
        
        for(var i in workspaces)
        {
            var workspace = workspaces[i];
            
            if(
                (
                    this_component.state.values.archive!=true
                    && workspace.state!='active'
                )
                ||
                (
                    ('workspaces' in this_component.state.filters) 
                    && (this_component.state.filters.workspaces.length > 0) 
                    && (
                        (!this_component.state.filters.workspaces.includes('-1'))
                        &&
                        (!this_component.state.filters.workspaces.includes(workspace.id))
                    )
                )
            ) continue;
            
            //console.log('workspace boards', workspace, boards);
            var items = boards.filter(function(board) { 
                return (
                    board.workspace_id == workspace.id
                    &&
                    (
                        this_component.state.values.archive==true
                        ||
                        (
                            this_component.state.values.archive!=true
                            &&
                            board.state=='active'
                        )
                    )
                ); 
            } );
            //console.log('workspace items',items);
            
            var label = workspace.name;
            if(workspace.state != 'active') label = workspace.name+' ('+workspace.state+')';
            
            options.boards.push( {'label': label, 'options': items.map( (item,index) => { 
                    var option = {'value': item.id.toString(), 'label': item.name};
                    if(item.state != 'active') option['label'] = item.name+' ('+item.state+')';
                    
                    return option;
                })  
            });
        }
        //console.log('update options', {...options});
        await this.promisedSetState( {'options': {...options} } );
        
        //remove boards from filters if they don't exists in available options
        if( ('filters' in this_component.state) && ('boards' in this_component.state.filters) && Array.isArray(this_component.state.filters.boards))
        {
            var filters = {...this_component.state.filters};
            var boards = filters.boards.filter(function(board_id) {
                return options.boards.filter(function(board) { if('value' in board) { return board.value==board_id; } else { return board.options.filter(function(option) { return option.value==board_id;}).length; } }).length;
            });
            
            if(filters.boards.length!=boards.length)
            {
                filters.boards = boards;
                await this.updateFilters(filters);
                return true;
            }
        }
        //end
        
        //set selected options
        var boards = [];
        
        if( ('filters' in this_component.state) && ('boards' in this_component.state.filters) && Array.isArray(this_component.state.filters.boards))
        {
            //console.log('filters boards', this_component.state.filters.boards);
            //console.log('options boards', this_component.state.options.boards);
            this_component.state.filters.boards.forEach(function(filter) {
                this_component.state.options.boards.forEach(function(options) {
                    if('value' in options)
                    {
                        if(filter == options.value)
                        {
                            boards.push(options);
                        }
                    }
                    else
                    {
                        var filtered = options.options.filter(function(board) { return filter == board.value; });
                        boards = boards.concat(filtered.filter((item) => boards.indexOf(item) < 0));
                    }
                });
            });
        }
        values.boards = boards;
        
        //console.log('values', values);
        //console.log('options', options);
        
        await this.promisedSetState( {'values': {...values} } );
        //end
        //await this.updateFilters(this_component.state.filters);
        return true;
    }
    
    async loadCacheData()
    {
        var this_component = this;
        if(this_component.state.cache.firstload === false)
        {
            this_component.loader.current.showLoader();
            var cache = {};
            cache.workspaces = await Monday.getWorkspaces(this_component.loader, ['active','archived','deleted']);
            cache.boards = await Monday.getBoards(this_component.loader, ['active','archived','deleted']);
            cache.firstload = true;
            await this.promisedSetState( {'cache': {...cache} } );

            await this_component.updateCheckboxes();
            await this_component.updateWorkspaceOptions();
            //await this_component.updateBordsOptions();

            this_component.loader.current.hideLoader();
        }
    }
    
    async componentDidMount()
    {
        var this_component = this;
        //console.log('filter componentDidMount', {...this.state});
        
        await this_component.loadCacheData();
    }
    
    async componentDidUpdate(prevProps)
    {
        var this_component = this;
        //console.log('filter componentDidUpdate', {...this.state});
        
        await this_component.loadCacheData();
        
        this_component.loader.current.showLoader();
        //console.log('componentDidUpdate', JSON.parse(JSON.stringify(prevProps)), JSON.parse(JSON.stringify(this.props)) );
        
        if( ('errors' in prevProps) && ('errors' in this_component.props) && JSON.stringify(prevProps.errors)!=JSON.stringify(this_component.props.errors))
        {
            var errors = this_component.props.errors;
            await this_component.promisedSetState( {'errors': {...errors} } );
            
            //console.log('componentDidUpdate errors', {...errors});
        }
        
        if( ('filters' in prevProps) && ('filters' in this_component.props) && JSON.stringify(prevProps.filters)!=JSON.stringify(this_component.props.filters))
        {
            //console.log('props.filters', {...this_component.props.filters});
            var filters = this_component.props.filters;
            await this_component.promisedSetState( {'filters': {...filters} } );
            
            
            
            await this_component.updateCheckboxes();
            await this_component.updateWorkspaceOptions();
        }
        
        this_component.loader.current.hideLoader();
    }
    
    render()
    {
        var this_component = this;
        
        return (
            <Loader ref={this_component.loader}>
                <div className="form-group mb-2" style={{'color':'var(--primary-text-color)'}}>
                    <div className="" style={{'display': 'flex', 'alignItems': 'center'}} >
                        <Checkbox className="pr-0 pt-2 pb-2" label="Include Archived/Deleted data" checked={this.state.values.archive} onChange={(e) => this.handleChangeCheckbox(e, 'archive')} />
                        <Dialog tooltip showTrigger={[Dialog.hideShowTriggers.CLICK]} hideTrigger={[Dialog.hideShowTriggers.CLICK,Dialog.hideShowTriggers.CLICK_OUTSIDE]} position={Dialog.positions.RIGHT} content={
                            <DialogContentContainer type={DialogContentContainer.types.POPOVER}>
                                <div style={{ 'backgroundColor': 'var(--primary-selected-color)', 'padding': '10px', 'width': '300px', 'justifyContent': 'center', 'color': 'var(--primary-text-color)' }}>
                                    Deleted boards/workspaces are available for export for 30 days, archived are available until deleted. <Link href={config.texts.url_filter_archived_deleted_info} text="More details" target={Link.targets.NEW_WINDOW} inlineText />.
                                </div>
                            </DialogContentContainer>
                        }>
                            <IconButton icon={Info} kind={IconButton.kinds.TERTIARY} size={IconButton.sizes.SMALL} />
                        </Dialog>
                        
                    </div>    
                </div>
                <div className="form-group mb-2">
                    <label className="" style={{'color':'var(--primary-text-color)'}}>Filter by Workspace</label>
                    <Dropdown value={this.state.values.workspaces} options={this.state.options.workspaces} multi multiline onChange={this.handleAddWorkspaces} onOptionRemove={this.handleRemoveWorkspaces} className={ ('filters.workspaces' in this_component.state.errors)?'dropdownError':null } />
                    {  ('filters.workspaces' in this_component.state.errors)?<div className="dropdownError errorMessage">{this_component.state.errors['filters.workspaces'].text}</div>:null }
                </div>
                <div className="form-group mb-2">
                    <label className="" style={{'color':'var(--primary-text-color)'}}>Filter by Boards</label>
                    <Dropdown value={this.state.values.boards} options={this.state.options.boards} multi multiline onChange={this.handleAddBoards} onOptionRemove={this.handleRemoveBoards} className={ ('filters.boards' in this_component.state.errors)?'dropdownError':null } />
                    {  ('filters.boards' in this_component.state.errors)?<div className="dropdownError errorMessage">{this_component.state.errors['filters.boards'].text}</div>:null }
                </div>
                
            </Loader>
        );
    }
}

Filter.propTypes = {
    'filters': PropTypes.object,
    'onChange': PropTypes.func,
};

Filter.defaultProps = {
    'filters': {},
    'onUpdate': undefined,
};

export default Filter;
